"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNumericArray = isNumericArray;
exports.sleep = sleep;
exports.getSize = getSize;
exports.attrd = attrd;
exports.kebabCase = kebabCase;
exports.minimum = minimum;
exports.sortDirection = sortDirection;
exports.Refresher = Refresher;
exports.removeElement = removeElement;
exports.shallowMerge = shallowMerge;
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
/** Decide whether all elements of `array` are of type `number`. */
function isNumericArray(array) {
  for (var i = 0, n = array.length; i < n; i++) {
    if (typeof array[i] !== 'number') {
      return false;
    }
  }
  return true;
}
/** Pause asynchronous execution for `ms` miliseconds.
 * (Use `await sleep(0)` to let other async things happen (this pushes the rest of the calling function to the end of the queue).) */
function sleep(ms) {
  return tslib_1.__awaiter(this, void 0, void 0, function () {
    return tslib_1.__generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, new Promise(function (resolve) {
            return setTimeout(resolve, ms);
          })];
        case 1:
          _a.sent();
          return [2 /*return*/];
      }
    });
  });
}
/** Return size of a DOM element `selection` */
function getSize(selection) {
  var _a = selection.node().getBoundingClientRect(),
    width = _a.width,
    height = _a.height;
  return {
    width: width,
    height: height
  };
}
/** Syntax sugar for applying attributes and styles to D3 selections.
 * Automatically converts camelCase to kebab-case.
 * (Don't use for attributes that are really camelCase, e.g. `viewBox`). */
function attrd(selection, attributes) {
  for (var name_1 in attributes) {
    if (name_1 !== 'style') selection.attr(kebabCase(name_1), attributes[name_1]);
  }
  for (var styleName in attributes.style) {
    selection.style(kebabCase(styleName), attributes.style[styleName]);
  }
  return selection;
}
/** Convert camelCaseString to kebab-case-string */
function kebabCase(str) {
  return str.replace(/([A-Z])/g, '-$1').toLowerCase();
}
/** Return the smallest of the given numbers. Ignore any nullish values. If all values are nullish, return `undefined`. */
function minimum() {
  var values = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    values[_i] = arguments[_i];
  }
  var definedValues = values.filter(function (x) {
    return !(0, lodash_1.isNil)(x);
  });
  if (definedValues.length > 0) return Math.min.apply(Math, definedValues);else return undefined;
}
/** Return 'asc' if values in array are strictly ascending.
 *  Return 'desc' if values in array are strictly descending.
 *  Return 'none' otherwise, or if array has fewer than 2 elements. */
function sortDirection(array) {
  var n = array.length;
  if (n < 2) return 'none';
  var direction = array[0] < array[1] ? 'asc' : 'desc';
  if (direction === 'asc') {
    for (var i = 1; i < n; i++) {
      if (array[i - 1] >= array[i]) return 'none';
    }
    return 'asc';
  } else {
    for (var i = 1; i < n; i++) {
      if (array[i - 1] <= array[i]) return 'none';
    }
    return 'desc';
  }
}
function Refresher(refresh) {
  var requested = false;
  var running = false;
  function requestRefresh() {
    requested = true;
    if (!running) {
      handleRequests(); // do not await
    }
  }
  function handleRequests() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!requested) return [3 /*break*/, 2];
            requested = false;
            running = true;
            return [4 /*yield*/, sleep(0)];
          case 1:
            _a.sent(); // let other things happen (this pushes the rest of the function to the end of the queue)
            try {
              refresh();
            } catch (err) {
              console.error(err);
            }
            running = false;
            return [3 /*break*/, 0];
          case 2:
            return [2 /*return*/];
        }
      });
    });
  }
  return {
    requestRefresh: requestRefresh
  };
}
/** Remove specific `element` from `array` if present, in place.
 * (Doesn't handle multiple occurrences of the same element.) */
function removeElement(array, element) {
  var i = array.indexOf(element);
  if (i >= 0) array.splice(i);
}
/** Create a copy of `old` and overwrite properties with `new_`.
 * Ignore properties in `new_` with value `undefined` (`null` behaves as normal value). */
function shallowMerge(old, new_) {
  var result = tslib_1.__assign({}, old);
  for (var key in new_) {
    var newValue = new_[key];
    if (newValue !== undefined) {
      result[key] = newValue;
    }
  }
  return result;
}